// extracted by mini-css-extract-plugin
export default {"container":"h7PLFJQu","container_electron":"I0vM5N9Z","containerElectron":"I0vM5N9Z","notification":"cBuXIi04","content":"FOpmIM3s","icon":"yRP0zVnL"};